// components
import { TimelineEvent } from 'react-event-timeline';
import { useTheme } from '@mui/material/styles';

// types
import { AuditServiceEntry } from 'app/modules/auditService/types';
import { formatDatetime } from 'app/shared/utils/date';
import { AUDIT_TRAIL_ACTION_TO_CONTENT } from 'app/modules/auditService/constants/auditTrailStrings';

interface Props extends AuditServiceEntry {}

export const AuditTrailEntry = ({
  action,
  actor,
  asset,
  details,
  createdAt,
}: Props) => {
  const theme = useTheme();
  const timestamp = formatDatetime(createdAt);
  const Content = AUDIT_TRAIL_ACTION_TO_CONTENT[action];
  return Content ? (
    <TimelineEvent
      title={timestamp}
      iconStyle={{ cursor: 'auto' }}
      contentStyle={{
        backgroundColor: theme.palette.background.neutral,
        borderRadius: theme.shape.borderRadius,
        boxShadow: 'none',
        color: theme.palette.text.primary,
      }}
      bubbleStyle={{
        background: theme.palette.background.paper,
        borderColor: theme.palette.info.main,
      }}
      titleStyle={{ color: theme.palette.text.primary }}
    >
      <Content actor={actor} asset={asset} details={details} />
    </TimelineEvent>
  ) : null;
};
